(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("gOTk6", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("gsN9U")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("gsN9U")).registerVersion; });

var $gsN9U = parcelRequire("gsN9U");
var $c3ec3ae0546d6a9a$var$name = "firebase";
var $c3ec3ae0546d6a9a$var$version = "9.6.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $gsN9U.registerVersion)($c3ec3ae0546d6a9a$var$name, $c3ec3ae0546d6a9a$var$version, "app");

});

})();
//# sourceMappingURL=index.esm.b82cf7e5.js.map
